import { LAT, LNG } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

export default [
  {
    [LNG]: -125.1545699,
    [LAT]: 49.25363276,
  },
  {
    [LNG]: -95.61155914,
    [LAT]: 49.53104359,
  },
  {
    [LNG]: -95.04704301,
    [LAT]: 49.71598415,
  },
  {
    [LNG]: -94.52956989,
    [LAT]: 49.11492734,
  },
  {
    [LNG]: -88.55510753,
    [LAT]: 48.56010568,
  },
  {
    [LNG]: -83.56854839,
    [LAT]: 46.52575958,
  },
  {
    [LNG]: -82.39247312,
    [LAT]: 45.64729194,
  },
  {
    [LNG]: -81.78091398,
    [LAT]: 44.49141347,
  },
  {
    [LNG]: -81.875,
    [LAT]: 43.33553501,
  },
  {
    [LNG]: -82.62768817,
    [LAT]: 42.22589168,
  },
  {
    [LNG]: -80.27553763,
    [LAT]: 42.82694848,
  },
  {
    [LNG]: -79.61693548,
    [LAT]: 43.10435931,
  },
  {
    [LNG]: -79.28763441,
    [LAT]: 43.98282695,
  },
  {
    [LNG]: -76.98252688,
    [LAT]: 44.07529723,
  },
  {
    [LNG]: -75.57123656,
    [LAT]: 45.23117569,
  },
  {
    [LNG]: -71.90188172,
    [LAT]: 45.36988111,
  },
  {
    [LNG]: -69.59677419,
    [LAT]: 47.77410832,
  },
  {
    [LNG]: -68.18548387,
    [LAT]: 47.68163804,
  },
  {
    [LNG]: -67.4327957,
    [LAT]: 47.17305152,
  },
  {
    [LNG]: -67.05645161,
    [LAT]: 45.97093791,
  },
  {
    [LNG]: -66.30376344,
    [LAT]: 44.81505945,
  },
  {
    [LNG]: -69.97311828,
    [LAT]: 43.24306473,
  },
  {
    [LNG]: -69.6438172,
    [LAT]: 42.22589168,
  },
  {
    [LNG]: -69.78494624,
    [LAT]: 40.79260238,
  },
  {
    [LNG]: -73.59543011,
    [LAT]: 40.05284016,
  },
  {
    [LNG]: -75.33602151,
    [LAT]: 37.09379128,
  },
  {
    [LNG]: -74.95967742,
    [LAT]: 35.29062087,
  },
  {
    [LNG]: -78.86424731,
    [LAT]: 33.16380449,
  },
  {
    [LNG]: -80.74596774,
    [LAT]: 31.40686922,
  },
  {
    [LNG]: -80.9811828,
    [LAT]: 30.667107,
  },
  {
    [LNG]: -79.75806452,
    [LAT]: 27.29194188,
  },
  {
    [LNG]: -79.71102151,
    [LAT]: 25.95112285,
  },
  {
    [LNG]: -80.08736559,
    [LAT]: 24.79524439,
  },
  {
    [LNG]: -81.02822581,
    [LAT]: 24.332893,
  },
  {
    [LNG]: -82.2983871,
    [LAT]: 24.10171731,
  },
  {
    [LNG]: -83.00403226,
    [LAT]: 24.56406869,
  },
  {
    [LNG]: -81.63978495,
    [LAT]: 25.21136063,
  },
  {
    [LNG]: -83.28629032,
    [LAT]: 27.43064729,
  },
  {
    [LNG]: -83.09811828,
    [LAT]: 28.91017173,
  },
  {
    [LNG]: -83.99193548,
    [LAT]: 29.60369881,
  },
  {
    [LNG]: -85.26209677,
    [LAT]: 29.18758256,
  },
  {
    [LNG]: -86.20295699,
    [LAT]: 29.92734478,
  },
  {
    [LNG]: -88.41397849,
    [LAT]: 29.8348745,
  },
  {
    [LNG]: -89.07258065,
    [LAT]: 28.6327609,
  },
  {
    [LNG]: -93.54166667,
    [LAT]: 29.37252312,
  },
  {
    [LNG]: -96.64650538,
    [LAT]: 27.84676354,
  },
  {
    [LNG]: -96.92876344,
    [LAT]: 26.55217966,
  },
  {
    [LNG]: -96.88172043,
    [LAT]: 25.62747688,
  },
  {
    [LNG]: -97.39919355,
    [LAT]: 25.35006605,
  },
  {
    [LNG]: -99.375,
    [LAT]: 26.18229855,
  },
  {
    [LNG]: -101.2567204,
    [LAT]: 29.14134742,
  },
  {
    [LNG]: -102.4327957,
    [LAT]: 29.37252312,
  },
  {
    [LNG]: -102.9502688,
    [LAT]: 28.72523118,
  },
  {
    [LNG]: -103.844086,
    [LAT]: 28.72523118,
  },
  {
    [LNG]: -105.1142473,
    [LAT]: 29.97357992,
  },
  {
    [LNG]: -106.6666667,
    [LAT]: 31.2681638,
  },
  {
    [LNG]: -111.4650538,
    [LAT]: 31.08322325,
  },
  {
    [LNG]: -114.9462366,
    [LAT]: 32.23910172,
  },
  {
    [LNG]: -117.3924731,
    [LAT]: 32.23910172,
  },
  {
    [LNG]: -119.3212366,
    [LAT]: 32.74768824,
  },
  {
    [LNG]: -121.0147849,
    [LAT]: 33.90356671,
  },
  {
    [LNG]: -123.0376344,
    [LAT]: 37.18626156,
  },
  {
    [LNG]: -124.7782258,
    [LAT]: 40.42272127,
  },
  {
    [LNG]: -124.7311828,
    [LAT]: 44.58388375,
  },
  {
    [LNG]: -125.3897849,
    [LAT]: 48.51387054,
  },
  {
    [LNG]: -154.4623656,
    [LAT]: 19.33949802,
  },
  {
    [LNG]: -156.061828,
    [LAT]: 18.41479524,
  },
  {
    [LNG]: -157.0967742,
    [LAT]: 20.0330251,
  },
  {
    [LNG]: -160.3427419,
    [LAT]: 21.42007926,
  },
  {
    [LNG]: -168.2459677,
    [LAT]: 24.88771466,
  },
  {
    [LNG]: -174.3145161,
    [LAT]: 25.71994716,
  },
  {
    [LNG]: -174.2674731,
    [LAT]: 26.50594452,
  },
  {
    [LNG]: -167.6344086,
    [LAT]: 25.30383091,
  },
  {
    [LNG]: -161.4247312,
    [LAT]: 23.08454425,
  },
  {
    [LNG]: -158.3669355,
    [LAT]: 22.20607662,
  },
  {
    [LNG]: -154.5564516,
    [LAT]: 19.94055482,
  },
  {
    [LNG]: -125.5,
    [LAT]: 49.23513871,
  },
  {
    [LNG]: -133.7163978,
    [LAT]: 54.47820343,
  },
  {
    [LNG]: -140.0201613,
    [LAT]: 59.10171731,
  },
  {
    [LNG]: -145.1478495,
    [LAT]: 59.51783355,
  },
  {
    [LNG]: -147.2647849,
    [LAT]: 58.87054161,
  },
  {
    [LNG]: -155.4502688,
    [LAT]: 55.35667107,
  },
  {
    [LNG]: -161.6129032,
    [LAT]: 53.73844122,
  },
  {
    [LNG]: -169.1397849,
    [LAT]: 52.12021136,
  },
  {
    [LNG]: -179.1599462,
    [LAT]: 50.77939234,
  },
  {
    [LNG]: -183.3938172,
    [LAT]: 51.334214,
  },
  {
    [LNG]: -188.1451613,
    [LAT]: 52.62879789,
  },
  {
    [LNG]: -187.6747312,
    [LAT]: 53.50726552,
  },
  {
    [LNG]: -185.6048387,
    [LAT]: 53.18361955,
  },
  {
    [LNG]: -182.0295699,
    [LAT]: 52.7675033,
  },
  {
    [LNG]: -178.125,
    [LAT]: 52.53632761,
  },
  {
    [LNG]: -172.6680108,
    [LAT]: 53.04491413,
  },
  {
    [LNG]: -168.8575269,
    [LAT]: 53.96961691,
  },
  {
    [LNG]: -164.2002688,
    [LAT]: 55.49537649,
  },
  {
    [LNG]: -158.5551075,
    [LAT]: 57.85336856,
  },
  {
    [LNG]: -167.7755376,
    [LAT]: 59.65653897,
  },
  {
    [LNG]: -167.7284946,
    [LAT]: 60.58124174,
  },
  {
    [LNG]: -166.4583333,
    [LAT]: 61.04359313,
  },
  {
    [LNG]: -166.6465054,
    [LAT]: 61.9682959,
  },
  {
    [LNG]: -164.811828,
    [LAT]: 63.49405548,
  },
  {
    [LNG]: -161.8481183,
    [LAT]: 63.95640687,
  },
  {
    [LNG]: -163.3534946,
    [LAT]: 64.2338177,
  },
  {
    [LNG]: -166.4112903,
    [LAT]: 64.09511229,
  },
  {
    [LNG]: -167.4932796,
    [LAT]: 64.64993395,
  },
  {
    [LNG]: -168.2930108,
    [LAT]: 63.12417437,
  },
  {
    [LNG]: -169.469086,
    [LAT]: 62.52311757,
  },
  {
    [LNG]: -171.9153226,
    [LAT]: 60.30383091,
  },
  {
    [LNG]: -169.9395161,
    [LAT]: 57.39101717,
  },
  {
    [LNG]: -169.0927419,
    [LAT]: 56.55878468,
  },
  {
    [LNG]: -169.9865591,
    [LAT]: 56.14266843,
  },
  {
    [LNG]: -170.7392473,
    [LAT]: 57.2985469,
  },
  {
    [LNG]: -170.5510753,
    [LAT]: 57.71466314,
  },
  {
    [LNG]: -172.1975806,
    [LAT]: 59.84147952,
  },
  {
    [LNG]: -173.655914,
    [LAT]: 60.58124174,
  },
  {
    [LNG]: -173.1384409,
    [LAT]: 61.13606341,
  },
  {
    [LNG]: -172.1505376,
    [LAT]: 60.71994716,
  },
  {
    [LNG]: -170.0336022,
    [LAT]: 62.70805812,
  },
  {
    [LNG]: -172.3387097,
    [LAT]: 63.21664465,
  },
  {
    [LNG]: -171.7741935,
    [LAT]: 64.28005284,
  },
  {
    [LNG]: -168.5752688,
    [LAT]: 63.77146631,
  },
  {
    [LNG]: -168.1048387,
    [LAT]: 64.55746367,
  },
  {
    [LNG]: -169.327957,
    [LAT]: 65.75957728,
  },
  {
    [LNG]: -168.5282258,
    [LAT]: 66.17569353,
  },
  {
    [LNG]: -164.2473118,
    [LAT]: 66.96169089,
  },
  {
    [LNG]: -167.3521505,
    [LAT]: 68.21003963,
  },
  {
    [LNG]: -166.7876344,
    [LAT]: 69.22721268,
  },
  {
    [LNG]: -163.3064516,
    [LAT]: 70.29062087,
  },
  {
    [LNG]: -159.4489247,
    [LAT]: 71.35402906,
  },
  {
    [LNG]: -154.5564516,
    [LAT]: 71.67767503,
  },
  {
    [LNG]: -140.8198925,
    [LAT]: 70.33685601,
  },
  {
    [LNG]: -140.4905914,
    [LAT]: 60.85865258,
  },
  {
    [LNG]: -138.702957,
    [LAT]: 60.67371202,
  },
  {
    [LNG]: -137.1975806,
    [LAT]: 59.51783355,
  },
  {
    [LNG]: -136.1155914,
    [LAT]: 60.39630119,
  },
  {
    [LNG]: -133.9045699,
    [LAT]: 59.332893,
  },
  {
    [LNG]: -129.5766129,
    [LAT]: 56.4663144,
  },
  {
    [LNG]: -129.6236559,
    [LAT]: 54.52443857,
  },
  {
    [LNG]: -131.2231183,
    [LAT]: 53.87714663,
  },
  {
    [LNG]: -125.1545699,
    [LAT]: 49.25363276,
  },
];
